import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col, Pagination, Form} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';
import moment from "jalali-moment";
import DatePickerField from "../formFields/DatePickerField";
import {CSVLink} from "react-csv";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'7%'
    },
    {
        title: 'شماره سفارش',
        dataIndex: 'order_code',
        sorter: (a, b) => a.order_code - b.order_code,
        width:'10%'
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width:"25%"
    },
    {
        title: 'استان',
        dataIndex: 'state',
        width:"10%"
    },
    {
        title: 'شهر',
        dataIndex: 'city',
        width:"10%"
    },
    {
        title: 'کد محصول',
        dataIndex: 'product_code',
        sorter: (a, b) => a.product_code - b.product_code,
        width:'10%'
    },
    {
        title: 'تعداد روز باقیمانده',
        dataIndex: 'reach_day',
        width:"10%",
        sorter: (a, b) => a.reach_day - b.reach_day,
    },
    {
        title: 'تاریخ تعویض',
        dataIndex: 'reach_date',
        width:"10%"
    },
    {
        title: 'تاریخ تکمیل سفارش',
        dataIndex: 'finished_date',
        width:"7%"
    },
  ];
const header = [
    {
        label: 'ردیف',
        key: 'key'
    },
    {
        label: 'شماره سفارش',
        key: 'order_code'
    },
    {
        label: 'عنوان',
        key: 'title'
    },
    {
        label: 'استان',
        key: 'state'
    },
    {
        label: 'شهر',
        key: 'city'
    },
    {
        label: 'کد محصول',
        key: 'product_code'
    },
    {
        label: 'تعداد روز باقیمانده',
        key: 'reach_day'
    },
    {
        label: 'تاریخ تعویض',
        key: 'reach_date'
    },
    {
        label: 'تاریخ تکمیل سفارش',
        key: 'finished_date'
    },
];


class ReminderList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            filter:[],
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
    }

    componentWillMount() {
        this.props.getList();
        // this.props.getListForExcel({size:10000});
        // this.props.getProductList({size:1000})
        this.props.getProductList({size:10})
        this.props.getAreaList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        let current_date = new Date();
        let reach_date;
        let stateName;
        let cityName;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                reach_date = new Date(list.lists[i].reach_date)
                let difference_in_days = 0
                if(current_date < reach_date) {
                    var difference_in_time = parseInt(reach_date.getTime()) - parseInt(current_date.getTime());
                    difference_in_days = difference_in_time / (1000 * 3600 * 24);
                }

                if(list.lists[i].stateTitle) {
                    stateName = list.lists[i].stateTitle
                }

                if(list.lists[i].cityTitle) {
                    cityName = list.lists[i].cityTitle
                }

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    order_code : list.lists[i].order && list.lists[i].order.system_code ? list.lists[i].order.system_code : '',
                    state : stateName ? stateName : '',
                    city : cityName ? cityName : '',
                    title : list.lists[i].product.title,
                    product_code : list.lists[i].product.system_code,
                    reach_day : Math.floor(difference_in_days),
                    reach_date : list.lists[i].reach_date ? moment(list.lists[i].reach_date).format('jYYYY/jM/jD') : '',
                    finished_date : list.lists[i].order && list.lists[i].order.finished_time ? moment(list.lists[i].order.finished_time).format('jYYYY/jM/jD') : '',
                });
            }
        }
        return dataSource;
    }

    __fixListForShowInExcel() {

        var list = this.props.listForExcel;
        var dataSource = [];
        let current_date = new Date();
        let reach_date;
        let stateName;
        let cityName;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                reach_date = new Date(list.lists[i].reach_date)
                let difference_in_days = 0
                if(current_date < reach_date) {
                    var difference_in_time = parseInt(reach_date.getTime()) - parseInt(current_date.getTime());
                    difference_in_days = difference_in_time / (1000 * 3600 * 24);
                }

                if(list.lists[i].cityTitle) {
                    cityName  = list.lists[i].cityTitle
                }
                if(list.lists[i].stateTitle) {
                    stateName = list.lists[i].stateTitle
                }

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    order_code : list.lists[i].order && list.lists[i].order.system_code ? list.lists[i].order.system_code : '',
                    state : stateName ? stateName : '',
                    city : cityName ? cityName : '',
                    title : list.lists[i].product.title,
                    product_code : list.lists[i].product.system_code,
                    reach_day : Math.floor(difference_in_days),
                    reach_date : list.lists[i].reach_date ? moment(list.lists[i].reach_date).format('jYYYY/jM/jD') : '',
                    finished_date : list.lists[i].order && list.lists[i].order.finished_time ? moment(list.lists[i].order.finished_time).format('jYYYY/jM/jD') : '',
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList()
        this.setState({current:1})
        this.props.getProductList()
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.created_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_from:this.state.created_from}
            }))
        if(this.state.created_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_to:this.state.created_to}
            }))
        if(this.state.stateId)
            this.setState(prevState  => ({
                filter: {...prevState.filter,state:this.state.stateId}
            }))
        if(this.state.city)
            this.setState(prevState  => ({
                filter: {...prevState.filter,city:this.state.city}
            }))
        if(this.state.product)
            this.setState(prevState  => ({
                filter: {...prevState.filter,product:this.state.product}
            }))
        this.props.handleSubmit(value);
        clearInterval(this.interval);
    }

    __goBack(){
        this.props.history.goBack()
    }
    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    __getProductList() {
        let list = this.props.productList;
        let dataSource = [];

        if (list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {

                dataSource.push(
                    {label: list.lists[i].title, value: list.lists[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;
        var data = this.__fixListForShowInExcel()

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();
        var cityList = [];

        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }
        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">یادآور</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length > 0 ?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={header}
                                    className='export-link'
                                    filename={"reminder_list.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                            </RTLButton>
                            : null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_from:created_from}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_to:created_to}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="state"
                                    component={SelectFieldForLoadState}
                                    placeholder="استان"
                                    list={stateList}
                                    onChangeVal={(stateId) => {
                                        _self.setState({stateId : stateId})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,stateId:stateId}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="city"
                                    component={SelectFieldForLoadCity}
                                    placeholder="شهر"
                                    list={cityList}
                                    onChange={(city) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,city:city}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="product"
                                    component={SelectField}
                                    placeholder="محصول"
                                    list={this.__getProductList()}
                                    onChange={(product) => this.setState({product:product})}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default ReminderList = reduxForm({
    form: 'list'
})(ReminderList)
